// LoginRedirectGuard.js
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import PageLoading from "src/component/PageLoading";
import { getCurrentAuthState } from "src/utils/authUtils";

const LoginRedirectGuard = ({ children }) => {
  const [redirectPath, setRedirectPath] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const authState = await getCurrentAuthState();

      console.log("🔐 [LoginRedirectGuard]", authState);

      if (!authState.isAuthenticated) {
        // Not logged in - show login/signup page
        setRedirectPath(null);
      } else if (authState.hasProfile) {
        // Logged in with profile - go to portfolio
        setRedirectPath("/secure/portfolio");
      } else {
        // Logged in but no profile - go to onboarding
        setRedirectPath("/secure/onBoarding");
      }

      setLoading(false);
    };

    checkAuthStatus();
  }, []);

  if (loading) return <PageLoading />;
  if (redirectPath) return <Redirect to={redirectPath} />;
  return children;
};

export default LoginRedirectGuard;